/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Input } from '@americanexpress/dls-react';
import { FxFormItem } from './FxFormItem';
import { getFieldStatus, getFieldErrorMessage } from '../../../utils/formUtils';

export const FxInputField = ({
  id,
  label,
  isRequired,
  className,
  canExecuteFieldOnChange,
  input: {
 value, onChange, onBlur, onFocus,
},
  meta,
  handleOnChange = () => {},
  handleOnBlur = () => {},
  handleOnFocus = () => {},
  showCustomError = false,
  showErrorModal = () => {},
  errorModalLabel = '',
  inputTheme,
  labelTheme,
  ...restProps
}) => {
  const status = getFieldStatus(meta, value);
  const errorMessage = getFieldErrorMessage(meta, status);

  // Change border color for custom error in H2H Protocol step
  const borderColor = showCustomError
    ? { '> input': { borderColor: '#EA700B !important' } }
    : { '> input': { borderColor: '#B42C01 !important' } };

  return (
    <FxFormItem
      id={id}
      className={className}
      label={label}
      isRequired={isRequired}
      status={status}
      errorMessage={errorMessage}
      showCustomError={showCustomError}
      showErrorModal={showErrorModal}
      errorModalLabel={errorModalLabel}
      labelTheme={labelTheme}
      isDisabled={restProps.disabled}
      {...restProps}
    >
      <Input
        theme={status === 'error' ? { ...inputTheme, ...borderColor } : { ...inputTheme }}
        id={id}
        value={value}
        status={status}
        describedBy={id}
        onChange={(e) => {
          if (canExecuteFieldOnChange) onChange(e);
          handleOnChange(e);
        }}
        onBlur={(e) => {
          onBlur(e);
          handleOnBlur(e);
        }}
        onFocus={(e) => {
          onFocus(e);
          handleOnFocus(e);
        }}
        {...restProps}
      />
    </FxFormItem>
  );
};

export default FxInputField;

FxInputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  canExecuteFieldOnChange: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({}).isRequired,
  handleOnChange: PropTypes.func,
  handleOnBlur: PropTypes.func,
  handleOnFocus: PropTypes.func,
  showCustomError: PropTypes.bool,
  showErrorModal: PropTypes.func,
  errorModalLabel: PropTypes.string,
  inputTheme: PropTypes.shape({}),
  labelTheme: PropTypes.shape({}),
};

FxInputField.defaultProps = {
  isRequired: false,
  className: null,
  canExecuteFieldOnChange: true,
  handleOnChange: () => {},
  handleOnBlur: () => {},
  handleOnFocus: () => {},
  inputTheme: {},
  labelTheme: {},
};
